function normalizeRoleNames (roleNames) {
  if (!roleNames || !roleNames.length) {
    return []
  }
  const names = []
  for (let i = 0; i < roleNames.length; i++) {
    const role = roleNames[i]
    if (typeof role === 'string') {
      names.push(role)
    } else if (role && role.name) {
      names.push(role.name)
    }
  }
  return names
}

/**
 * Country code, a dash, then the last 7 characters of the agent profile id (hyphens stripped).
 * Example: GHA + c9f1feb → GHA-C9F1FEB
 */
function formatAgentPhotoIdNumber (agentProfileId, countryId) {
  if (!agentProfileId || !countryId) {
    return ''
  }
  const compact = String(agentProfileId).replace(/-/g, '')
  if (compact.length < 7) {
    return ''
  }
  return String(countryId).toUpperCase() + '-' + compact.slice(-7).toUpperCase()
}

/**
 * Highest extra role only. Terminal supervisor wins, then route supervisor, then driver, then staff.
 * Regular agents (no extra role) return null.
 */
function resolveAgentPhotoIdRoleLabel (roleNames) {
  const names = normalizeRoleNames(roleNames)
  const has = {}
  for (let i = 0; i < names.length; i++) {
    has[names[i]] = true
  }
  if (has.terminalsupervisor) {
    return 'Terminal Staff'
  }
  if (has.routesupervisor) {
    return 'Route Supervisor'
  }
  if (has.agentdriver) {
    return 'Driver'
  }
  if (has.agentstaff) {
    return 'Agent Staff'
  }
  return null
}

function canIssueAgentPhotoIdCard (roleNames) {
  return resolveAgentPhotoIdRoleLabel(roleNames) !== null
}

module.exports = {
  formatAgentPhotoIdNumber,
  resolveAgentPhotoIdRoleLabel,
  canIssueAgentPhotoIdCard
}
